import styled from 'styled-components';
import { spacing, body2 } from 'ui/theme';

export const Cell = styled.div`
  ${body2};
  box-sizing: border-box;
  display: table-cell;
  vertical-align: middle;
  overflow-y: visible;
  padding: ${spacing.threeQuarter};
  margin: 0;
`;

export const RightAlignText = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: end;
`;

export const TabularNumberFont = styled.div`
  font-feature-settings: 'tnum';
`;
